module.exports = __webpack_public_path__ + "static/media/01.c9ceb700.jpg";